export enum SymbolAlertType {

    Price = 1,
    ChangePercent = 2,
    Signal = 3,
}
